import { render } from "./ReportNotify.vue?vue&type=template&id=28d69730"
import script from "./ReportNotify.vue?vue&type=script&lang=js"
export * from "./ReportNotify.vue?vue&type=script&lang=js"

import "./ReportNotify.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__